import React from 'react';
import { Modal, ModalProps } from './Modal';
import classNames from 'classnames';
import { Button } from '../Button';

export type ConfirmationModalProps = ModalProps & {
  onConfirm?: () => Promise<void>;
  onCancel?: () => Promise<void>;
  children: React.ReactNode;
  actionButtons?: (onConfirm?: () => Promise<void>) => React.ReactNode;
};

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  contentClassName,
  onConfirm,
  onCancel,
  children,
  setIsOpen,
  actionButtons,
  ...props
}) => {
  const handleConfirm = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    onConfirm && (await onConfirm());
    setIsOpen(false);
  };

  const handleCancel = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    onCancel && (await onCancel());
    setIsOpen(false);
  };

  return (
    <Modal
      setIsOpen={setIsOpen}
      {...props}
      contentClassName={classNames(
        'w-[95%] max-w-[400px] rounded-2xl',
        contentClassName
      )}
    >
      <div>
        <div className={classNames({ 'mt-8': !props.title })}>{children}</div>

        {actionButtons ? (
          actionButtons(onConfirm)
        ) : (
          <div className="mt-4 flex justify-end gap-1">
            <Button variant="base" size="sm" onClick={handleCancel}>
              Cancel
            </Button>
            <Button size="sm" variant="danger" onClick={handleConfirm}>
              Delete
            </Button>
          </div>
        )}
      </div>
    </Modal>
  );
};
